import { TIMESTAMP, PT_BR } from '@/utils/dateFormats';
import { formatDate } from '@/utils/tableColumns';

export default {
  cambioItens: [],
  selectedCambio: {},
  colunasDisponiveis: [
    {
      label: 'referenciaCliente',
      field: 'referenciaCliente',
      width: '176px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'referenciaTrust',
      field: 'codigoProcesso',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
    {
      label: 'invoice',
      field: 'codigoInvoice',
      width: '107px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'Exportador',
      field: 'nomeExportador',
      width: '190px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'modalidade',
      field: 'modalidade',
      width: '263px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'porcentagem',
      field: 'pctValor',
      width: '175px',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      maxWidth: 108,
    },
    {
      label: 'tipoVencimento',
      field: 'tipoVencimento',
      width: '170px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'vencimento',
      field: 'dataVencimento',
      width: '140px',
      hidden: false,
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
    },
    {
      label: 'moeda',
      field: 'moeda',
      width: '117px',
      hidden: false,
      type: 'text',
    },
    {
      label: 'valor',
      field: 'valor',
      width: '100px',
      hidden: false,
      type: 'text',
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'cambio',
        fetch: 'fetchInformacoesCambio',
      },
      flex: 1,
    },
  ],
  colunasDinamicasCambio: [],
};
